import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgDrag = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M10.8 12a.3.3 0 1 1 0-.019M6.8 12a.3.3 0 1 1 0-.019M10.8 8a.3.3 0 1 1 0-.019M6.8 8a.3.3 0 1 1 0-.019M10.8 4a.3.3 0 1 1 0-.019M6.8 4a.3.3 0 1 1 0-.019"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDrag);
export default ForwardRef;
